import { useContext, useState } from 'react'
import { GameContext } from '../GameContextF.jsx'
import { RoundedButton } from '../GameCompsF.jsx'
import { DebugUpdateGameStateBtn, HardResetGameBtn } from '../LeaveGameBtnF.jsx'
import { Ptext } from '../../../componentsF/Chakra3F/ChakraF.jsx'
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody } from '@chakra-ui/react'
import { HostSettingsPanel } from '../HostSettingsPanelAI.jsx'

export const HostSettingsBtn = () => {
  const {isHost} = useContext(GameContext)
  const [showSettings, setShowSettings] = useState(false)

  if (!isHost) return null

  return <>
    <RoundedButton {...{onClick: () => setShowSettings(true), mb: 2}}>
      Room Settings
    </RoundedButton>
    <Modal {...{isOpen: showSettings, onClose: () => setShowSettings(false)}}>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        <ModalBody>
          <HostSettingsPanel {...{onClose: () => setShowSettings(false)}} />
        </ModalBody>
      </ModalContent>
    </Modal>
  </>
}

export const HostControls = () => {
  const {setIsKickingPlayer, isHost} = useContext(GameContext)

  if (!isHost) return null
  
  return <>
    <Ptext {...{mt: 5, fontSize: '5xl'}}>Host Options</Ptext>
    <HostSettingsBtn />
    <RoundedButton {...{onClick: () => setIsKickingPlayer(true)}}>
      Kick Player
    </RoundedButton>
    <DebugUpdateGameStateBtn />
    <HardResetGameBtn />
  </>
}
